// Copyright 2026 Rockyljewell
// SPDX-License-Identifier: Apache-2.0

export const VERSION = "1.0.0";
